var ChoiceTypes = /*#__PURE__*/function (ChoiceTypes) {
  ChoiceTypes["radio"] = "radio";
  ChoiceTypes["checkbox"] = "checkbox";
  ChoiceTypes["switch"] = "switch";
  return ChoiceTypes;
}({});
export { ChoiceTypes };